import styled from 'styled-components'
import { Popover } from '../Popover'
import { spacing } from '../_styles/spacing'

export const StyledFilterPresetPopoverContent = styled(Popover.Content)`
  padding: ${spacing.sm}px ${spacing.lg}px;
`
